import { SafeArea } from 'capacitor-plugin-safe-area';

export default {
  data() {
    return {
      safeAreaInsetProp: 'padding-top',
      safeAreaDefaultInsetValue: '30px',
      safeAreaInsetStyle: 'padding-top: 30px',
    };
  },
  created() {
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      var topPadding = this.safeAreaDefaultInsetValue;
      if (insets.top && insets.top > 10) {
        topPadding = `${insets.top}px`;
      }
      this.safeAreaInsetStyle = `${this.safeAreaInsetProp}: ${topPadding}`;
    });
  },
};
